import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, reset } from 'redux-form';
import clone from 'lodash/clone';
import { notification } from 'antd';
import ForecastAdd from '../../components/molecules/ForecastAdd/index';
import { isOpen } from '../../store/modal/selectors';
import { modalHide } from '../../store/modal/actions';
import { createValidator, required } from '../../services/validation/index';
import { resourceCreateRequest } from '../../store/resource/actions';

const ForecastsAddContainer = props => <ForecastAdd {...props} />;

const onSubmit = (values, dispatch, { createForecast, onCancel }) => {
  const submitVals = clone(values);
  submitVals.start_date = values.rangepicker[0];
  submitVals.end_date = values.rangepicker[1];
  delete submitVals.rangepicker;

  return createForecast(submitVals)
    .then(id => {
      // Saga runs to redirect
      notification.success({ message: 'Success', description: 'Forecast created.', duration: 4 });
      onCancel();
    })
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not create forecast.',
        duration: 0,
      });
    });
};

const validate = createValidator({
  name: [required],
});

const mapStateToProps = ({ modal, updateForecast, ...state }) => ({
  visible: isOpen(modal, 'add-forecast'),
  initialValues: {
    ...updateForecast,
  },
});

const mapDispatchToProps = dispatch => ({
  createForecast: data => dispatch(resourceCreateRequest('forecast', {}, data)),
  onCancel: () => {
    dispatch(modalHide('add-forecast'));
    dispatch(reset('ForecastAdd'));
  },
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    enableReinitialize: true,
    destroyOnUnmount: false,
    form: 'ForecastAdd',
    onSubmit,
    validate,
  })
)(ForecastsAddContainer);
